import { render, staticRenderFns } from "./DevicePendingList.vue?vue&type=template&id=11117445&scoped=true&"
import script from "./DevicePendingList.vue?vue&type=script&lang=js&"
export * from "./DevicePendingList.vue?vue&type=script&lang=js&"
import style0 from "./DevicePendingList.vue?vue&type=style&index=0&id=11117445&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11117445",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCardText,VDataTable})
